import React from 'react'
import PropTypes from 'prop-types'
import { PortalHeader } from 'components'
import { useCommunity } from 'utils'

const propTypes = {
  children: PropTypes.node.isRequired,
}

function Layout({ children }) {
  const {
    defaultBranding: { dashboardHeader },
  } = useCommunity()

  return (
    <div>
      <PortalHeader backgroundImage={dashboardHeader} />
      <div className="content-block-container learning-hub-my-profile">
        {children}
      </div>
    </div>
  )
}

Layout.propTypes = propTypes

export default Layout
